import { useState } from "react";
import { Receipt as ReceiptIcon, ListOrdered } from "lucide-react";
import { PosPage } from "../Pos/PosPage";
import { FiscalDocumentsListPage } from "./FiscalDocumentsListPage";

type TabKey = "kasa" | "racuni";

export function FiscalizationHubPage() {
  const [tab, setTab] = useState<TabKey>("kasa");

  // Root uslovno menja layout po tabu (24.09.2026, PRAVI koren "cela strana
  // ima skrol" bag-a na kasi) - ranije je koren UVEK bio prost blok div
  // ("space-y-4", bez visine), pa je PosPage-ov "h-full" grid pokušavao da
  // se osloni na visinu OVOG diva, koji nema definisanu visinu (auto) - a
  // procentualna visina nasuprot "auto" roditelju se po CSS specifikaciji
  // IGNORIŠE. Zato ni AppShell.tsx (<main>) ni ProductGrid/Cart min-h-0
  // ispravke nisu mogle da pomognu - lanac se lomio baš ovde, iznad njih
  // svih. Za "Kasa" tab sad je koren fleks-kolona koja popunjava CELU
  // raspoloživu visinu (h-full), sa tab trakom fiksne visine (shrink-0) i
  // sadržajem koji uzima ostatak (min-h-0 flex-1) - to je konačno definitivna
  // visina koju PosPage-ov h-full grid ispravno nasleđuje. Za "Poslednji
  // računi" tab layout OSTAJE nepromenjen (space-y-4, prirodan tok/skrol
  // kroz <main>) - ta lista ne treba fiksnu visinu, i ne diramo je.
  return (
    <div className={tab === "kasa" ? "flex h-full min-h-0 flex-col gap-4" : "space-y-4"}>
      <div className="flex shrink-0 gap-1 border-b border-border">
        <button
          onClick={() => setTab("kasa")}
          className={`flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "kasa" ? "border-brand text-brand" : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <ReceiptIcon className="h-4 w-4" aria-hidden />
          Kasa
        </button>
        <button
          onClick={() => setTab("racuni")}
          className={`flex items-center gap-1.5 border-b-2 px-4 py-2 text-sm font-medium ${
            tab === "racuni" ? "border-brand text-brand" : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <ListOrdered className="h-4 w-4" aria-hidden />
          Poslednji računi
        </button>
      </div>

      {tab === "kasa" ? (
        <div className="min-h-0 flex-1">
          <PosPage />
        </div>
      ) : (
        <FiscalDocumentsListPage onAdvanceClosed={() => setTab("kasa")} />
      )}
    </div>
  );
}
